<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10ujrTU/tc-custom/9780830866793.jpg?1696025451694" alt="This image is the cover for the book Creating a Missional Culture, Forge Partnership Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Creating a Missional Culture, Forge Partnership Books
      </h1>
      <p class="bookDescription body article font2">
        <p>Once upon a time, Moses had had enough. Exhausted by the challenge of leading the Israelites from slavery to the Promised Land, Moses cried out to God, "What have I done to displease you that you put the burden of all these people on me? . . . If this is how you are going to treat me, please go ahead and kill me" (Exodus 11:11, 15). If that sounds hauntingly familiar to you, you may be the senior pastor of a contemporary church. The burden of Christian leadership is becoming increasingly unbearable--demanding skills not native to the art of pastoring; demanding time that makes sabbath rest and even normal sleep patterns seem extravagant; demanding inhuman levels of efficiency, proficiency and even saintliness. No wonder pastors seem and even feel less human these days. No wonder they burn out or break down at an alarming rate; no wonder the church is missing the mark on its mission. In<em>Creating a Missional Culture,</em> JR Woodward offers a bold and surprisingly refreshing model for churches--not small adjustments around the periphery of a church's infrastructure but a radical revisioning of how a church ought to look, from its leadership structure to its mobilization of the laity. The end result looks surprisingly like the church that Jesus created and the apostles cultivated: a church not chasing the wind but rather going into the world and making disciples of Jesus.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        JR Woodward, Alan Hirsch
      </h2>
      
      <p class="authorDescription body article"><p>JR Woodward (MA, Fuller Theological Seminary) is a church planter, activist, missiologist and the national director for church planting with V3, a missional church planting movement. He is the author of <em>Creating a Missional Culture</em> and he desires to awaken people to join God in the renewal of all things. JR is founder of New Life Christian Fellowship (NLCF) and cofounder of Kairos LA, the Solis Foundation, Ecclesia Network and Missio Alliance. He serves locally with the District Church in Washington D.C. and is pursuing a PhD at the University of Manchester (UK). He loves to surf, travel, read, skateboard and meet new people. He enjoys photography and film and tries to attend the Sundance Film Festival whenever he can.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45bf8ff4